<ng-content> </ng-content>
<chart-zoom-controls
  *ngIf="svgContainer && rectZoom"
  [zoom]="zoom"
  [padding]="padding"
  [svgContainer]="svgContainer"
  [rectZoom]="rectZoom"
  [shapeWrapper]="shapeWrapper"
  [enableZoomScroll]="enableZoomScroll"
  (trackEvent)="trackEvent.emit($event)"
></chart-zoom-controls>
